import React, { useState } from 'react';
import { TransactionSearchOperation } from '../../types';
import { useAppContext } from '../context/AppContext';
import { ViewStateEnum } from '../context/viewStateEnum';
import MainView from './MainView';
import ErrorView from '../status/ErrorView';
import { FormattedMessage } from 'react-intl';
import Spinner from '../application/components/Spinner';
import TransactionStatus from "./TransactionStatus";

const ContentWrapper = () => {
  const { viewState } = useAppContext();


  const simpleResult: { transactionSearcherData: any[] } = {
    transactionSearcherData: [],
  };

  const [transactionSearchResult, setTransactionSearchResult] =
    useState<TransactionSearchOperation>(simpleResult);

  const defineDisplayView = () => {
    switch (viewState.state) {
      case ViewStateEnum.SHOW_ERROR: {
        return <ErrorView errorMessage={viewState.data} />;
      }
      case ViewStateEnum.SHOW_RESULT: {
        return (
            <TransactionStatus
                transactionSearchResult={transactionSearchResult}
            />
        );
      }

      case ViewStateEnum.SHOW_SPINNER: {
        return (
          <main>
            <div className="column column-2">
              <article className="search-form">
                <header className="row">
                  <h1>{<FormattedMessage id="transactionStatus.header" />}</h1>
                </header>
                <div className="spinner-background">
                  <Spinner />
                </div>
              </article>
            </div>
          </main>
        );
      }
      default: {
        return (
          <MainView setTransactionSearchResult={setTransactionSearchResult} />
        );
      }
    }
  };

  return defineDisplayView();
};

export default ContentWrapper;
